import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SplashScreenService } from '@clean-code/shared/common';
import { SideNavService } from '../services/side-nav.service';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  imports: [RouterModule, SideNavComponent, UserMenuComponent],
})
export class LayoutComponent implements OnInit {
  public service = inject(SideNavService);
  private readonly splashScreen = inject(SplashScreenService);

  ngOnInit(): void {
    this.splashScreen.hideState();
  }

  public toggleUserMenu(): void {
    this.service.toggleUserMenu();
  }
}
